import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './DashboardSidebar.css';

export default function DashboardSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <aside className="dashboard-sidebar">
      <div className="sidebar-title">Admin Dashboard</div>
      <nav>
        <ul>
          <li
            className={isActive('/dashboard') && !isActive('/dashboard/products') && !isActive('/dashboard/discounts') && !isActive('/dashboard/stickers') ? 'active' : ''}
            onClick={() => navigate('/dashboard')}
          >
            Porositë
          </li>
          <li
            className={isActive('/dashboard/products') ? 'active' : ''}
            onClick={() => navigate('/dashboard/products')}
          >
            Produktet
          </li>
          <li
            className={isActive('/dashboard/discounts') ? 'active' : ''}
            onClick={() => navigate('/dashboard/discounts')}
          >
            Zbritjet
          </li>
          <li
            className={isActive('/dashboard/stickers') ? 'active' : ''}
            onClick={() => navigate('/dashboard/stickers')}
          >
            Stickers
          </li>
        </ul>
      </nav>
    </aside>
  );
}
